// Popup function in Vanilla JS
function Popup(selector, options = {}) {
  const settings = Object.assign(
    {
      centerPopup: true,
      open: function () {},
      closed: function () {},
    },
    options
  );

  const popup = document.querySelector(selector);
  if (!popup) return;

  let background = document.querySelector(".PopupBackground");
  if (!background) {
    background = document.createElement("div");
    background.classList.add("PopupBackground");
    document.body.prepend(background);
  }

  let closeBtn = popup.querySelector(".PopupClose");
  if (!closeBtn) {
    closeBtn = document.createElement("div");
    closeBtn.classList.add("PopupClose");
    closeBtn.textContent = "X";
    popup.prepend(closeBtn);
  }

  // Position popup
  function positionPopup() {
    const winWidth = window.innerWidth;
    const winHeight = window.innerHeight;
    const popupWidth = popup.offsetWidth;
    const popupHeight = popup.offsetHeight;

    let top = winHeight / 2 - popupHeight / 2;
    let left;

    if (winWidth < 767) {
      left = winWidth / 2 - popupWidth / 1.7;
    } else if (winWidth < 1025) {
      left = winWidth / 2 - popupWidth / 1.9;
    } else {
      left = winWidth / 2 - popupWidth / 2;
    }

    if (top < 30) top = 30;

    popup.style.position = "absolute";
    popup.style.top = `${top}px`;
    popup.style.left = `${left}px`;
  }

  // Show popup
  function showPopup() {
    background.style.opacity = "0.7";
    background.style.display = "block";
    popup.style.display = "block";
    popup.style.opacity = "1";

    if (settings.centerPopup) positionPopup();
    settings.open();
  }

  // Hide popup
  function hidePopup() {
    background.style.display = "none";
    popup.style.display = "none";
    removeEventListeners();
    settings.closed();
  }

  // Event handlers
  function addEventListeners() {
    closeBtn.addEventListener("click", hidePopup);
    background.addEventListener("click", hidePopup);
    window.addEventListener("resize", onResize);
  }

  function removeEventListeners() {
    closeBtn.removeEventListener("click", hidePopup);
    background.removeEventListener("click", hidePopup);
    window.removeEventListener("resize", onResize);
  }

  function onResize() {
    if (settings.centerPopup) positionPopup();
  }

  // Initialize
  addEventListeners();
  showPopup();
}

